import { IconProps } from "../../utils/global-types/global-types";

const FinanceIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className}
    {...rest}
  >
    <g clipPath="url(#clip0_4130_53474)">
      <g fill="currentColor" clipPath="url(#clip1_4130_53474)">
        <path d="M6.219 1C3.735 1 1 1.62 1 2.907s2.735 1.875 5.219 1.875c2.483 0 5.156-.587 5.156-1.875S8.702 1 6.219 1"></path>
        <path d="M6.219 5.72C3.734 5.72 1 5.128 1 3.843v.938c0 1.284 2.734 1.875 5.219 1.875 2.484 0 5.156-.59 5.156-1.875v-.938c0 1.285-2.672 1.875-5.156 1.875M11.844 6.657c-.37 0-.72.035-1.03.103a5.166 5.166 0 0 0-4.126 5.053c0 1.493.643 2.938 1.763 3.909A5.15 5.15 0 0 0 11.844 17C14.687 17 17 14.657 17 11.813a5.16 5.16 0 0 0-5.156-5.156m-.272 4.687h1.21a.469.469 0 1 1 0 .938h-1.17a2 2 0 0 1-.204.62c.282.082.547.234.768.455a.86.86 0 0 0 1.212 0 .469.469 0 1 1 .663.662c-.35.35-.81.525-1.27.525s-.918-.175-1.268-.525a.87.87 0 0 0-.946-.18q-.166.125-.338.239a.469.469 0 0 1-.591-.721q.196-.195.428-.317c.32-.255.496-.495.578-.758H9.97a.468.468 0 1 1 0-.938h.647l-.169-.845c-.009-1.126.832-1.967 1.866-1.967s1.875.84 1.875 1.875a.469.469 0 1 1-.937 0 .939.939 0 0 0-1.875 0zM6.702 15.072c-.162.005-.323.022-.483.022-2.485 0-5.219-.59-5.219-1.875v.938c0 1.284 2.734 1.906 5.219 1.906.402 0 .796-.023 1.183-.053a6.3 6.3 0 0 1-.7-.938"></path>
        <path d="M5.917 13.215C3.523 13.169 1 12.577 1 11.345v.937c0 1.284 2.734 1.875 5.219 1.875h.006a6 6 0 0 1-.308-.942"></path>
        <path d="M5.792 11.338C3.438 11.274 1 10.68 1 9.469v.938c0 1.208 2.426 1.802 4.775 1.868-.012-.153-.025-.307-.025-.462 0-.162.03-.316.042-.475"></path>
        <path d="M6.219 9.47C3.734 9.47 1 8.878 1 7.593v.938c0 1.236 2.536 1.828 4.937 1.87q.114-.481.304-.934zM11.372 5.742h.003V5.72q-.002.011-.003.023"></path>
        <path d="M6.219 7.594C3.734 7.594 1 7.004 1 5.72v.938C1 7.94 3.734 8.532 6.219 8.532q.26 0 .522-.01.346-.533.794-.985c-.434.038-.878.057-1.316.057"></path>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4130_53474">
        <path fill="#fff" d="M0 0h18v18H0z"></path>
      </clipPath>
      <clipPath id="clip1_4130_53474">
        <path fill="#fff" d="M1 1h16v16H1z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default FinanceIcon;
